// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapLink } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { NewsBar } from '../_components/ui';
/**
 * Component capable of rendering the `NewsBarModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let NewsBarModuleUi = class NewsBarModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Items to render.
         */
        this.items = [];
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const itemsToResolve = this.module.content.items || [];
        try {
            await Promise.all(itemsToResolve.map(item => {
                return new Promise((resolve, reject) => {
                    if (!item.related) {
                        this.items = [...this.items, {
                                ...item,
                                contentSneakPeak: null
                            }];
                        resolve();
                    }
                    this.relatedService.resolve(item.related, {})
                        .then(article => {
                        this.items = [...this.items, {
                                ...item,
                                contentSneakPeak: article
                            }];
                        resolve();
                    })
                        .catch(e => {
                        if (this.debug)
                            console.warn(e);
                        reject(e);
                    });
                });
            }));
        }
        catch (e) {
            this.onError(e);
        }
        this.items.length > 0 ? this.onReady() : this.onError();
    }
};
NewsBarModuleUi = __decorate([
    Component({
        name: 'NewsBarModuleUi',
        components: {
            BootstrapLink,
            NewsBar
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="news-bar-module" :class="[debugClass, loadingClass, moduleColoredClass, getThemeByBgClass]">
    <NewsBar :color="module.content.color"
             :style="{'font-size' : module.content.fontSize + 'px'}">
      <ul class="news-bar-module__list list-inline">
        <li v-for="(item, i) in items" :key="item.label + '-' + i"
            class="news-bar-module__list__item list-inline-item">
          <BootstrapLink v-if="!!item.contentSneakPeak" :link="{ target: item.contentSneakPeak.urlPath }">
            {{ item.label }}
          </BootstrapLink>
          <BootstrapLink v-else :link="{ target: item.externalUrl, isExternal: true }">
            {{ item.label }}
          </BootstrapLink>
        </li>
      </ul>
    </NewsBar>
    </section>
  `
    })
], NewsBarModuleUi);
export { NewsBarModuleUi };
